import { CheckCircle2, Clock, AlertCircle, FileText } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface MetaStatusIndicatorsProps {
  checkedByCoder: boolean;
  issueCount: number;
  activeIssues: number;
}

export function MetaStatusIndicators({ checkedByCoder, issueCount, activeIssues }: MetaStatusIndicatorsProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Coder Status Icon */}
      <Tooltip>
        <TooltipTrigger asChild>
          {checkedByCoder ? (
            <CheckCircle2 className="h-4 w-4 text-green-600" />
          ) : (
            <Clock className="h-4 w-4 text-yellow-600" />
          )}
        </TooltipTrigger>
        <TooltipContent>
          <p>{checkedByCoder ? "Approved by clinical coder" : "Awaiting clinical coder approval"}</p>
        </TooltipContent>
      </Tooltip>

      {/* Issues Status Icon */}
      <Tooltip>
        <TooltipTrigger asChild>
          {issueCount === 0 ? (
            <CheckCircle2 className="h-4 w-4 text-green-600" />
          ) : activeIssues > 0 ? (
            <AlertCircle className="h-4 w-4 text-red-600" />
          ) : (
            <FileText className="h-4 w-4 text-blue-600" />
          )}
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {issueCount === 0
              ? "No reported issues"
              : activeIssues > 0
                ? `${activeIssues} active issue${activeIssues !== 1 ? "s" : ""} need attention`
                : `${issueCount} resolved issue${issueCount !== 1 ? "s" : ""}`}
          </p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
